<template>
  <ion-page>
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-buttons slot="start">
          <ion-back-button
            default-href="/support"
            color="light"
            text=""
          ></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title">Guidelines</ion-title>
      </ion-toolbar>
    </ion-header>
    <!--content start -->
    <ion-content>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">How to connect wallet</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">However a small line</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">Can I use multiple discount codes?</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">Will I be charged for an exchange?</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">Do you accept replacements?</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt"
            >Will I be charged for a replacement item?</span
          >
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">How do I make an exchange?</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">When will I be charged for my order?</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">Are there any return exclusions?</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row router-link="/support-post" class="support-row">
        <ion-col size="9">
          <span class="support-txt">Whats your return policy?</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <hr class="support-row" />
      <!-- content end -->
    </ion-content>
  </ion-page>
</template>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.support-row {
  border-top: 1px solid #f3f3f3;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 3%;
}
.support-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding-top: 5px;
}
.arrowright-icon {
  text-align: right;
  padding-top: 8px;
}
.position-right {
  position: absolute;
  right: 20px;
}
</style>
<script>
import { defineComponent } from "vue";
import {
  IonRow,
  IonCol,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
} from "@ionic/vue";

export default defineComponent({
  name: "SupportListPage",
  components: {
    IonRow,
    IonCol,
    IonButton,
    IonPage,
    IonContent,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
  },
});
</script>
